import {
  TOGGLE_PROFILE_DROPDOWN,
  TOGGLE_NOTIFICATION_DROPDOWN,
  TOGGLE_LIVE_STATUS_DROPDOWN,
  CLOSE_ALL_DROPDOWNS,
  NEXT_PAGE,
  PREV_PAGE,
  GO_TO_PAGE,
  TOGGLE_VIEW,
  SET_ACTIVE_ITEM,
} from "./Action";

export const initialState = {
  profileDropdownOpen: false,
  notificationDropdownOpen: false,
  liveStatusDropdownOpen:false,
  isListView: false,
  currentPage: 1,
  itemsPerPage: 10,
  totalItems: 100,
  totalPages: 1,
  activeItem: "Overview"  ,
};

export const reducer = (state, action) => {
  switch (action.type) {
    case TOGGLE_PROFILE_DROPDOWN:
      return {
        ...state,
        profileDropdownOpen: !state.profileDropdownOpen,
        notificationDropdownOpen: false,
      };
    case TOGGLE_NOTIFICATION_DROPDOWN:
      return {
        ...state,
        notificationDropdownOpen: !state.notificationDropdownOpen,
        profileDropdownOpen: false,
      };


    case TOGGLE_LIVE_STATUS_DROPDOWN:
      return {
        ...state,
        liveStatusDropdownOpen: !state.liveStatusDropdownOpen,
        // profileDropdownOpen: false,
      };
    case TOGGLE_VIEW:
      return { ...state, isListView: !state.isListView };
    case NEXT_PAGE:
      return {
        ...state,
        currentPage: Math.min(state.currentPage + 1, state.totalPages),
      };
    case PREV_PAGE:
      return {
        ...state,
        currentPage: Math.max(state.currentPage - 1, 1),
      };
    case GO_TO_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SET_ACTIVE_ITEM:
      return {
        ...state,
        activeItem: action.payload,
      };
    case CLOSE_ALL_DROPDOWNS:
      return {
        ...state,
        profileDropdownOpen: false,
        notificationDropdownOpen: false,
        liveStatusDropdownOpen: false,
      };
    default:
      return state;
  }
};
